import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import {
  StatisticsResponse,
  StatisticBar,
  StatisticsFiltersData,
  StatisticsRequestsResponse,
} from './models/StatisticsModels';

export class ApiStatistics extends ApiHexaBase {
  public static statisticsBaseUrl(id: string | number): string {
    return `${ApiHexaBase.baseUrl}/customers/${id}/statistics`;
  }

  public static async index(
    id: string | number,
    params: {
      start_date?: string;
      end_date?: string;
      url_names?: string[];
      methods?: string[];
      status_codes?: number[];
    }
  ): Promise<StatisticsResponse> {
    const response = await ApiBase.post(this.statisticsBaseUrl(id), {
      start_date: params.start_date,
      end_date: params.end_date,
      url_names: params.url_names,
      methods: params.methods,
      status_codes: params.status_codes,
    });

    return response.data.data as {
      total: number;
      statistics: StatisticBar[];
    };
  }

  /**
   * Single requests (newest first) matching the same filters of the statistics,
   * with their details, consumer and IP. Paginated on the server.
   */
  public static async requests(
    id: string | number,
    params: {
      page: number;
      size: number;
      start_date?: string;
      end_date?: string;
      url_names?: string[];
      methods?: string[];
      status_codes?: number[];
    }
  ): Promise<StatisticsRequestsResponse> {
    const response = await ApiBase.post(
      `${this.statisticsBaseUrl(id)}/requests?page=${params.page}&size=${params.size}`,
      {
        start_date: params.start_date,
        end_date: params.end_date,
        url_names: params.url_names,
        methods: params.methods,
        status_codes: params.status_codes,
      }
    );

    return response.data.data as StatisticsRequestsResponse;
  }

  public static async get_filters_data(
    id: string | number
  ): Promise<StatisticsFiltersData> {
    const response = await ApiBase.get(
      `${this.statisticsBaseUrl(id)}/filters_data`
    );

    return response.data.data as {
      url_names: string[];
      methods: string[];
      status_codes: string[];
      contract_start_date: string;
      contract_end_date: string;
    };
  }

  public static async download_data(
    id: string | number,
    params: {
      start_date?: string;
      end_date?: string;
      url_names?: string[];
      methods?: string[];
      status_codes?: number[];
    }
  ): Promise<any> {
    const response = await ApiBase.post(
      `${this.statisticsBaseUrl(id)}/download`,
      {
        start_date: params.start_date,
        end_date: params.end_date,
        url_names: params.url_names,
        methods: params.methods,
        status_codes: params.status_codes,
      },
      'blob'
    );

    return response.data;
  }
}
